<div class="arcgis-custom-map-form-wrapper">
  <form [formGroup]="arcGisCustomElevationForm">
    <div class="arcGis-fields">
      <div class="form-row">
        <mat-form-field>
          <mat-select formControlName="SecurityType" required placeholder="{{ 'sources.details.Security' | translate }}">
            <mat-option *ngFor="let type of securityTypes" [value]="type.value">
              {{ type.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="getControlError('SecurityType')">{{ 'validation.required' | translate: { name: 'Map Type' } }} </mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field>
          <input
            matInput
            formControlName="ElevationServerUrl"
            name="mapServerUrl"
            placeholder="{{ 'components.dtmTab.customElevations.elevationServerUrl' | translate }}"
            required
            autocomplete="off"
            meeRemoveAutofill
          />
          <mat-error *ngIf="getControlError('ElevationServerUrl')"
            >{{ 'validation.required' | translate: { name: ('company.baseMaps.mapServerUrl' | translate) } }}
          </mat-error>
          <mat-error
            *ngIf="
              arcGisCustomElevationForm.get('ElevationServerUrl').errors &&
              arcGisCustomElevationForm.get('ElevationServerUrl').errors.notUnique
            "
          >
            {{ 'components.dtmTab.customElevations.customMapUniqueMapServerUrl' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-row" [class.hidden]="!isArcGisPassword()">
        <mat-form-field>
          <input
            matInput
            formControlName="AuthenticationUrl"
            name="AuthenticationUrl"
            [required]="isArcGisPassword()"
            placeholder="{{ 'sources.fields-placeholders.AuthenticationUrl' | translate }}"
            autocomplete="off"
            meeRemoveAutofill
          />
          <mat-error *ngIf="getControlError('AuthenticationUrl')"
            >{{ 'validation.required' | translate: { name: ('sources.fields-placeholders.AuthenticationUrl' | translate) } }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mee-vertical-datum formControlName="VerticalDatum"></mee-vertical-datum>
      </div>

      <div
        class="form-row"
        [class.hidden]="!isArcGisPassword() || !arcGisCustomElevationForm.get('AuthenticationUrl').value"
      >
        <mat-form-field>
          <input
            matInput
            [type]="'text'"
            formControlName="ArcGisUsername"
            name="username"
            [required]="isArcGisPassword() && arcGisCustomElevationForm.get('AuthenticationUrl').value !== ''"
            placeholder="{{ 'sources.fields-placeholders.Username' | translate }}"
            autocomplete="off"
            meeRemoveAutofill
          />
          <mat-error *ngIf="getControlError('ArcGisUsername')">{{ 'validation.required' | translate: { name: ('sources.fields-placeholders.Username' | translate) } }} </mat-error>
        </mat-form-field>

        <mat-form-field>
          <input
            type="password"
            matInput
            [required]="isArcGisPassword()"
            formControlName="Password"
            name="password"
            placeholder="{{ 'sources.fields-placeholders.Password' | translate }}"
            autocomplete="off"
            meeRemoveAutofill
          />
          <mat-error *ngIf="getControlError('Password')">{{ 'validation.required' | translate: { name: ('sources.fields-placeholders.Password' | translate) } }} </mat-error>
        </mat-form-field>
      </div>

      <div class="optional-inputs arcGisOnline">
        <mat-slide-toggle formControlName="IsArcGisOnline" name="isArcGisOnline" color="primary">
          {{ 'sources.fields-placeholders.IsArcGisOnline' | translate }}
        </mat-slide-toggle>
      </div>
    </div>
  </form>
</div>
